import { computed, ref } from 'vue-demi';
import getUrlParam from '@/utils/helpers/getUrlParam';

const EXPERIMENT_DEBUG_QUERY_PARAM = 'experimentDebug';
const experimentDebug = ref(false);

export default function useExperimentDebug() {
  /**
   * Checks if experiment is to be bypassed via `experimentDebug` query parameter and
   * tracks as stateful experimentDebug ref.
   *
   * @return {Boolean} Returns `true` if experiment is to be bypassed, else `false`
   */
  const isExperimentDebugEnabled = computed(() => {
    const expDebugQueryParam = getUrlParam(EXPERIMENT_DEBUG_QUERY_PARAM);

    if (['true', '1'].includes(expDebugQueryParam)) {
      experimentDebug.value = true;
    } else if (['false', '0', ''].includes(expDebugQueryParam)) {
      experimentDebug.value = false;
      window.location = window.location.hash.split('?')[0];
    }

    return experimentDebug.value;
  });

  return {
    isExperimentDebugEnabled,
  };
}
